import { TdsTextField } from "@scania/tegel-react";
import { useFormContext } from "react-hook-form";
import { debounce } from "lodash";
import { useEffect, useMemo } from "react";
import type { JSX } from '@scania/tegel';



interface TextFieldPropType extends JSX.TdsTextField {
  onValueChange?: (newtValue: string) => void
  dataFieldName: string
  required?: string
  pattren?: string | RegExp
  pattrenErrorMessage?: string
}

const TextField = (props: TextFieldPropType) => {
  const { value, onValueChange, dataFieldName, required, pattren, pattrenErrorMessage } = props
  const { setValue, getValues, register, formState, getFieldState, setError, clearErrors, unregister } = useFormContext();
  const selectValue = getValues(dataFieldName);
  const fieldState = getFieldState(dataFieldName, formState);

  const state = (required !== "" && fieldState.isTouched && selectValue === "") || fieldState.error?.type === 'required' || fieldState.error?.type === 'validate' ? "error" : "default";

  const validatonRules: Record<string, any> = useMemo(() => {
    const validatonRules: Record<string, any> = {};
    if (required && required !== "") {
      validatonRules["required"] = required
    }
    validatonRules["validate"] = (newValue: string) => {
      if (pattren && pattren !== '' && newValue !== '') {
        const pattrenRegex = new RegExp(pattren);
        if (!pattrenRegex.test(newValue)) {
          return false
        } else {
          return true
        }
      } else {
        return true;
      }
    }
    return validatonRules
  }, [required, pattren])

  useEffect(() => {
    unregister(dataFieldName)
    register(dataFieldName, validatonRules)
    return () => {
      unregister(dataFieldName)
    }
  }, [dataFieldName, validatonRules, register, unregister])


  const onTdsChange = (e: any) => {
    onValueChange && onValueChange(e.target.value);
    setValue(dataFieldName, e.target.value);
    if (e.target.value !== '' && pattren) {
      const pattrenRegex = new RegExp(pattren);
      if (!pattrenRegex.test(e.target.value)) {
        setError(dataFieldName, { message: pattrenErrorMessage, type: "validate" }, { shouldFocus: true })
      } else {
        clearErrors(dataFieldName)
      }

    }
  }

  useEffect(() => {
    if (value) {
      setValue(dataFieldName, value);
    }
  }, [value, setValue, dataFieldName])

  const onTouchOrClick = (e: any) => {
    // console.log(e.target.value);
  }

  return <>
    <TdsTextField {...props}
      helper={(state === "error" && selectValue === "") || fieldState.error?.type === 'required' ? validatonRules.required : (state === 'error' && fieldState.error?.type === 'validate' ? pattrenErrorMessage : "")}
      onTdsInput={debounce(onTdsChange, 300)}
      state={state}
      value={selectValue}
      onTouchStart={onTouchOrClick}
      onClick={onTouchOrClick}
      labelPosition={props.labelPosition || 'outside'}
    />
  </>
}

export default TextField